import styled from "styled-components";

export const Container = styled.div `
    background-image: linear-gradient(to bottom,  #353535 95%, #35353500);
    padding: 70px 0 30px 0;
    margin-bottom: 5px;

    @media (max-width: 800px) {
        padding: 60px 0 30px 0;
    }
`

export const Content = styled.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-height: 80dvh;
    width: 98%;
    padding: 20px;
    aspect-ratio: 16/9;
    margin: 0 auto;
    background: #202020;
    border-radius: 20px;
    border: 3px solid #fff;
    opacity: .5;
    filter: blur(1px);

    header {
        display: flex;
    }

    header div {
        padding: 10px 30px;
        border-radius: 50px;
        background: #606060;
        margin-right: 10px;
    }

    main {
        margin: 20px 0;
    }

    main .title {
        padding: 30px;
        width: 90%;
        max-width: 50%;
        border-radius: 50px;
        background: #606060;
        margin-bottom: 20px;
    }

    main .subtitle {
        width: 40%;
        padding: 10px 30px;
        border-radius: 50px;
        background: #606060;
        margin-bottom: 5px;
    
    }

    main .subtitle:last-child {
        width: 30%;
    }

    footer {
        display: flex;
    }

    footer div {
        padding: 20px 60px;
        border-radius: 50px;
        background: #606060;
        margin-bottom: 5px;
    }

    @media (max-width: 800px) {
        justify-content: end;
        align-items: center;
        min-height: 63dvh;
        max-height: 63dvh;
        width: 95%;

        main {
            display: flex;
            justify-content: center;
            width: 100%;
            margin: 5px 0 20px 0;
        }

        main .title {
            display: flex;
            min-width: 80%;
            max-width: 80%;
            padding: 20px;
            margin-bottom: 0;
        }

        footer {
            display: none;
        }

        main .subtitle {
            display: none;
        }
    }
`